// Copyright 2020 Cognite AS
var SDK_LIST_LIMIT = 1000;
var SDK_EXCLUDE_FROM_TRACKING_METHODS = [
    'setOneTimeSdkHeader',
    'project',
    'loginWithOAuth',
    'loginWithApiKey',
    'setBaseUrl',
    'getMetadata',
    'get',
    'put',
    'post',
    'delete',
];

export { SDK_LIST_LIMIT as S, SDK_EXCLUDE_FROM_TRACKING_METHODS as a };
